<template>
  <div id="help">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>人员管理&nbsp;/&nbsp;帮厨管理</span>
      </div>
      <div style="display: flex;flex-wrap: wrap;align-items: center;">
        <Week @childFn="parentFn"></Week>
       <el-input class="elinputs" v-model="poper" placeholder="姓名"></el-input>
       <el-input
          class="elinputs"
          v-model="helperPhone"
          placeholder="手机号"
        ></el-input>
        <el-select
          v-model="healthy"
          placeholder="健康证状态"
          class="elinputs"
        >
          <el-option
            v-for="item in healthyList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button
          type="primary"
          element-loading-text="加载中..."
          element-loading-background="rgba(0, 0, 0, 0.4)"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="query"
        >查询</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <div>
        <div class="tit">
          <span>
            总计：
            <i style="color:#11A983;font-weight:600">{{ total }}</i> 条
          </span>
          <Xlsx :name="formname"></Xlsx>
        </div>
      </div>
      <el-table :data="tableData" id="exportTab" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
        <el-table-column prop="helperName" label="姓名" width="120"></el-table-column>
        <el-table-column prop="helperPhone" label="手机号" width="160"></el-table-column>
        <el-table-column min-width="120" label="身份证正面照">
          <template slot-scope="scope">
            <!-- <img :src="scope.healthPhoto" alt=""> -->
            <viewer>
              <img class="sfzimg" :src="imgUrl+scope.row.frontPhoto" />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="身份证反面照">
          <template slot-scope="scope">
            <!-- <img :src="scope.healthPhoto" alt=""> -->
            <viewer>
              <img class="sfzimg" :src="imgUrl+scope.row.backPhoto" />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="健康证照片">
          <template slot-scope="scope">
            <viewer>
              <img class="sfzimg" :src="imgUrl+scope.row.healthPhoto" />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column prop="healthPhotoNum" min-width="180" label="健康证编号">

        </el-table-column>
        <el-table-column label="健康证状态" width="140">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.hstate == 1" style="color: #67c23a">正常</p>
            <p
              class="boldfont"
              v-if="scope.row.hstate == 3"
              style="color: #f56c6c"
            >
              过期
            </p>
            <p
              class="boldfont"
              v-if="scope.row.hstate == 2"
              style="color: #e6a23c"
            >
              即将过期
            </p>
          </template>
        </el-table-column>
        <el-table-column min-width="160" label="健康证过期时间">
          <template slot-scope="scope">
            <p>{{ scope.row.healthPhotoValidity }}</p>
          </template>
        </el-table-column>
        <el-table-column label="启用状态" width="120">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.state==1" style="color: #67c23a">启用</p>
            <p class="boldfont" v-else style="color:#F56C6C">禁用</p>
          </template>
        </el-table-column>
        <el-table-column min-width="180" label="创建时间">
          <template slot-scope="scope">
            <p>{{ scope.row.createTime }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="handleEdit(scope.row)">
              <i class="el-icon-edit"></i> 查看
            </el-button>
            <el-button size="mini" :class="scope.row.state=='1'?'f56':'c23'" @click="stop(scope.row,'bc:prohibit')"><i class="el-icon-remove-outline"></i>
              <span class="boldfont" v-if="scope.row.state==1">禁用</span>
              <span class="boldfont" v-else>启用</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <span>共<i class="pagingNum">{{ total }}</i> 条</span>
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog title="帮厨详情" :visible.sync="dialogFormVisible" class="myxx" width="60%">
      <div class="details">
        <p>
          姓名：
          <span></span>
          {{information.helperName}}
        </p>
        <p>
          电话：
          <span></span>
          {{information.helperPhone}}
        </p>
        <p>
          健康证过期时间：
          <span></span>
          {{information.healthPhotoValidity}}
        </p>
        <p>
          健康证编号：
          <span></span>
          {{information.healthPhotoNum}}
        </p>
        <p>
          健康证状态：
          <span v-if="information.hstate == 1" style="color: #67c23a; font-weight: 600;">正常</span>
          <span v-if="information.hstate == 3" style="color: #f56c6c; font-weight: 600;">过期</span>
          <span v-if="information.hstate == 2" style="color: #e6a23c; font-weight: 600;">即将过期</span>
        </p>
        <p>
          创建时间：
          <span></span>
          {{information.createTime}}
        </p>
      </div>

      <div class="boxsfz" id="boxsfz">
        <div>
          <viewer>
            <img class="sfzimgs" :src="imgUrl+information.frontPhoto" mode=""/>
          </viewer>
          <h5>身份证正面照</h5>
        </div>
        <div>
          <viewer>
            <img class="sfzimgs" :src="imgUrl+information.backPhoto" />
          </viewer>
          <h5>身份证反面照</h5>
        </div>
        <div>
          <viewer>
            <img class="sfzimgs" :src="imgUrl+information.healthPhoto" />
          </viewer>
          <h5>健康证照片</h5>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button class="newbtn" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Week from "@/components/Week";
import Xlsx from "@/components/Xlsx";
import Paging from '@/components/Paging';
export default {
  name: "help",
  components: {
    Week,
    Xlsx,
    Paging
  },
  data() {
    return {
      healthy: "", //健康状态
      healthyList: [
        { value: 1, name: "正常" },
        { value: 2, name: "即将过期" },
        { value: 3, name: "过期" },
      ],
      poper: "",
      helperPhone: "",
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      information: {},
      userdata: {},
      total: 0,
      btn: [],
      areaId: "",
      fullscreenLoading: true,
      imgUrl: this.$Public.imgUrl,
      formname: JSON.stringify({name:'帮厨管理',hint:'xc:export'}),
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
    const ViewerDom = document.getElementById("boxsfz");
    // const viewer = new Viewer(ViewerDom, {
    //     // 配置
    // })
  },
  methods: {
    parentFn(i) {
      this.areaId = i.id;
    },
    reset() {
      this.$router.push("/refresh");
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin();
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        helperName: this.poper,
        helperPhone: this.helperPhone,
        adminAreasId: userdata.areasId,
        healthStatus: this.healthy,
        areaId: this.areaId
      });
      this.$axios
        .post(`/api-r/user/getKitchenHelperList`, data, {
          headers: { accessToken: userdata.token }
        })
        .then(res => {
          // console.log(res);
          if(res.data.success){
            this.fullscreenLoading = false;
            this.$set(this, "tableData", res.data.pageInfo.list);
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
                type: 'success',
                message: res.data.msg
            });
          }else{
            this.$message(res.data.msg)
          }
        });
    },
    handleEdit(i) {
      this.dialogFormVisible = true;
      this.$set(this, "information", i);
    },
    stop(row,hint) {
      if(this.btn.indexOf(hint)==-1){
          return this.$message('抱歉，用户暂无该权限')
      }
      this.$axios
        .post(
          `/api-r/user/prohibitHelper/${row.hid}`,
          {},
          { headers: { accessToken: this.userdata.token } }
        )
        .then(res => {
          if (res.data.success == true) {
            this.$message({
              type: "success",
              message: res.data.msg
            });
            this.begin();
          } else {
            alert(res.data.msg);
          }
        });
    },
    query() {
      this.$set(this, "total", 1);
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
#help .el-input__inner {
  margin: 10px 0;
}
#help .el-pagination__sizes .el-input__inner {
  margin: 0;
}
/* 暂无数据样式 */
#help .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
/* #help .el-select {
  margin: 0 8px;
} */
#help .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
#help .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#help .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#help .el-dialog__body {
  height: 382px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  width: 60px;
  height: 48px;
}
.sfzimgs {
  width: 60px;
  height: 180px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
.boxsfz {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.boxsfz img {
  width: 100%;
}
.boxsfz > div {
  width: 30%;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.newbtn {
  background-color: #11A983;
  color: #fff;
}
.details {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  p {
    width: 50%;
  }
}
</style>
